import { PortableText } from '@portabletext/react';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import CTA2 from '@/components/CTA2';

type LeftTextInsideImageProps = {
  anchor?: string;
  image: any;
  text:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  ctas: any[];
};

const LeftTextInsideImage = ({
  anchor,
  image,
  text,
  ctas,
}: LeftTextInsideImageProps) => {
  return (
    <section
      id={anchor}
      className="max-w-8xl mx-auto flex flex-col justify-center mt-16 bg-overlayBg bg-top bg-blend-overlay bg-cover lg:min-h-[550px] scroll-mt-[150px]"
      style={{ backgroundImage: `url('${getSanityImageUrl(image)}')` }}
    >
      <div className="w-full lg:w-1/2 [&>p]:my-6 [&>h5]:font-bold [&>h5]:text-3xl [&>ul]:list-disc [&>ul>li]:pb-2 [&>ul>li]:ml-4 bg-white px-8 py-6 ml-16 my-8 rounded">
        {text && <PortableText value={text} />}
        {ctas && ctas.map((cta: any) => <CTA2 key={cta._key} {...cta} />)}
      </div>
    </section>
  );
};

export default LeftTextInsideImage;
